export const routeAccessTree = {
  account: {
    public: false,
    register: {
      public: false,
    },
    ":id": {
      public: false,
      edit: {
        public: false,
      },
    },
  },

  client: {
    public: false,
    register: {
      public: false,
    },
    ":id": {
      public: false,
      edit: {
        public: false,
      },
    },
  },

  site: {
    public: false,
    register: {
      public: false,
    },
    ":id": {
      public: false,
      edit: {
        public: false,
      },
      drawing: {
        public: false,
        ":drawingId": {
          public: false,
          "floor-plans": {
            public: false,
          },
        },
      },
      inspection: {
        public: false,
        ":folderId": {
          public: false,
        },
      },
      parsing: {
        public: false,
      },
    },
  },

  login: {
    public: true,
  },
};
